<template>
    <div class="relative">
        <div @click="showDropdown"
            :class="'mt-2 lg:text-sm xl:text-base md:hover:font-bold md:hover:border-b-neutral-100 border-b-2 border-transparent whitespace-nowrap cursor-pointer' + ' ' + (dropdownVisible ? 'font-bold' : '')">
            <span>
                {{ title }}
            </span>
            <span v-if="dropdownVisible">
            </span>
        </div>

<!--         Dropdown menu-->
        <div v-if="dropdownVisible" id="dropdown"
            class="shadow-dropdown absolute top-[45px] right-0 z-10 p-4 rounded-lg w-[169px] bg-white">
            <ul class="">
                <li v-for="link in links" class="group w-fit leading-snug tracking-tighter lg:text-sm xl:text-base font-medium hover:font-bold first:mt-0 mt-2 hover:border-b-neutral-100 border-b-2 border-transparent">
                    <Link v-if="link.target === 'internal'"
                        class="block px-2 py-1 group-last:rounded-b-lg cursor-pointer"
                        :href="link.dest">
                    {{ link.title }}
                    </Link>
                    <Link v-else class="block " :href="link.dest">
                        {{ link.title }}
                    </Link>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HeaderLinkDropdown',
    props: {
        title: {
            type: String,
            default: 'Title'
        },
        links: {
            type: Array,
            default: {
                title: 'Link',
                url: '#'
            }
        }
    },
    data() {
        return {
            dropdownVisible: false
        }
    },
    methods: {
        showDropdown() {
            this.dropdownVisible = true;
            setTimeout(() => {
                document.addEventListener('click', this.closeDropdown);
            }, 1);


        },
        closeDropdown() {
            this.dropdownVisible = false;
            setTimeout(() => {
                document.removeEventListener('click', this.closeDropdown);
            }, 1);
        }
    },
    mounted() {
    },
}
</script>

<style scoped>
.shadow-dropdown {
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}
</style>
